import { useWindows } from "@/os/window/context";
import { useSettings } from "@/os/state/settings";
import { EGGS, useAchievements } from "@/os/state/achievements";
import { BRAIN_FILES } from "@/data/brain";
import { play } from "@/lib/sound";
import { Lock } from "lucide-react";

export function MyBrain() {
    const { open } = useWindows();
    const { sliders } = useSettings();
    const { allEggs, eggs } = useAchievements();

    const files = BRAIN_FILES.filter((f) => {
        if (f.id === "found-everything") return allEggs;
        if (f.curiosityLocked) return sliders.curiosity >= 70;
        return true;
    });

    return (
        <div data-testid="my-brain">
            <p className="font-mono text-[11px] text-inkfaint">
                {files.length} files · curiosity, thinking process and personal interests. ({eggs.length}/{EGGS.length} easter eggs found so far.)
            </p>
            <div className="mt-3 space-y-1">
                {files.map((f) => {
                    const Icon = f.icon;
                    return (
                        <button
                            key={f.id}
                            data-testid={`brain-file-${f.id}`}
                            className="file-row"
                            onClick={() => {
                                play("click");
                                open(f.kind === "tabs" ? "tabs" : `file:${f.id}`);
                            }}
                        >
                            <Icon size={16} style={{ color: "#A855F7", flex: "none" }} />
                            <span className="truncate">{f.name}</span>
                            {f.curiosityLocked && (
                                <span className="badge">
                                    <Lock size={9} /> curiosity
                                </span>
                            )}
                            {f.kind === "final-egg" && <span className="badge border-butterd bg-butter/40">reward</span>}
                            <span className="file-meta">
                                {f.size}
                                <br />
                                {f.modified}
                            </span>
                        </button>
                    );
                })}
            </div>
            {!allEggs && (
                <p className="mt-4 font-mono text-[10.5px] text-inkfaint">
                    rumor: a reward file appears here once every easter egg in the OS is found.
                </p>
            )}
        </div>
    );
}
